import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link, useParams } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
import Whatsnew from './whatsnew';
import CountUp from 'react-countup'
import Accordin from './Accordin'
import Benefits from './Benefits'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetStudyDestinationCountryTopUniversityIndividualUniversityApiQuery } from '../../../core/Features/api/studyDestination/StudyDestination';
import Unlock from '../../HomePages/home-palani/section/Unlock';
import LightboxGallery from '../../LightboxGallery';

const IndividualUniversity = () => {

    const { id } = useParams();
    const { data, isLoading, isError } = useGetStudyDestinationCountryTopUniversityIndividualUniversityApiQuery(id || {});


    const apiValues = data?.data || {};



    const bgImageUrl = "/assets/img/backgroundpalanicard/cardbackground.jpg";


    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);

    return (
        <>
            <>

                {/* banner */}
                <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0 bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues?.IndividualUniversityDetails?.bannerImageUrl})`,
                            backgroundSize: "100% 100%",

                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues?.IndividualUniversityDetails?.bannerTitle}
                                            </h6>
                                            <p className="text-white fs-14">
                                                {apiValues?.IndividualUniversityDetails?.bannerDescription} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <LightboxGallery gallaryVal={apiValues?.IndividualUniversityDetails?.galleryImage} />

                <div className='p-3'>

                    {/* <div className="section student-course"> */}
                    <div className="container mt-4">
                        <div className="course-widget">
                            <div className="row row-gap-4">

                                {

                                    (Array.isArray(apiValues?.IndividualUniversityDetails?.miniCard) ? apiValues?.IndividualUniversityDetails?.miniCard : []).map((item: any, index: number) => {

                                        return (

                                            <div className="col-lg-3 col-md-6 d-flex">
                                                <div className="expert-item flex flex-col  aos">
                                                    <div className="expert-img">
                                                        <ImageWithBasePath
                                                            source={
                                                                item?.iconUrl
                                                            }
                                                            className="rounded-full "
                                                            style={{
                                                                height:40,
                                                                width:40
                                                            }}
                                                            alt="Img"
                                                        />

                                                    </div>
                                                    <div className="expert-content">
                                                        <h4>
                                                            {/* <span className="counterup">
                                                                <CountUp end={10} />10
                                                            </span>K */}
                                                            {item.title}
                                                        </h4>
                                                        <p>
                                                            {item.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>



                                        )

                                    }) || []

                                }
                            </div>
                        </div>
                    </div>
                    {/* </div> */}



                    <div className="flex flex-col lg:flex-row gap-4 w-full mt-3 p-2 lg:min-h-[300px]">
                        {/* Accordion Section - Left */}
                        <div
                            className="w-full lg:w-[75%] lg:h-full flex flex-col rounded-md border border-gray-300 p-5"

                        >
                            <Accordin apiValues={apiValues} />
                        </div>

                        {/* Counselor Card - Right */}
                        <div
                            className="w-full lg:w-[25%] lg:h-full flex flex-col rounded-md border border-gray-300 p-5 space-y-2 bg-cover bg-center"

                            style={{
                                backgroundImage: `url(${bgImageUrl})`,
                            }}
                        >
                            <ImageWithBasePath
                                src="assets/img/individual/image2.png"
                                alt="img"
                                className="w-full h-auto"
                            />

                            <h5 className="mt-4 font-semibold text-lg">
                                {apiValues?.IndividualUniversityDetails?.collapseRightSideImage?.title}
                            </h5>

                            <p className="mt-4 text-sm text-gray-600">
                                {apiValues?.IndividualUniversityDetails?.collapseRightSideImage?.description}
                            </p>

                            <Link to={route.Unlock} className="bg-[#392C7D] text-center text-white rounded-full py-2 px-6 mt-4 hover:bg-[#2e2364] transition">
                                {apiValues?.IndividualUniversityDetails?.collapseRightSideImage?.buttonText}
                            </Link>

                            <div className="flex justify-center mt-auto pt-4">
                                <ImageWithBasePath
                                    source={apiValues?.IndividualUniversityDetails?.collapseRightSideImage?.imageUrl}
                                    alt="img"
                                    className="w-32 h-auto sm:w-36 md:w-40"
                                />
                            </div>
                        </div>

                    </div>


                    {/* <Whatsnew /> */}

                    <div>
                        <Benefits apiValues={apiValues} />
                    </div>



                    <Unlock />


                </div>




            </>

        </>
    )
}

export default IndividualUniversity
